import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LorenAssetReportsComponent} from './components/loren-asset-reports/loren-asset-reports.component';

const routes: Routes = [
    {
        path: '',
        component: LorenAssetReportsComponent,
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LorenAssetReportsRoutingModule {
}
